import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=ce79fa94&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "./Chat.vue?vue&type=style&index=0&id=ce79fa94&prod&scoped=true&lang=css"
import style1 from "./Chat.vue?vue&type=style&index=1&id=ce79fa94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce79fa94",
  null
  
)

export default component.exports